import React from 'react'
import {Dropdown, ListGroup } from 'react-bootstrap'
import {IPartner} from "../../../types/partners/IPartner";
import {VacancyCompanyHook} from "../../../api/vacancy-company/vacancy-company.api";
import {EditVacancyCompany} from "./edit-vacancy-company";
import {RemoveVacancyCompany} from "./remove-vacancy-company";

type Props = {
  partner: IPartner
}

export const VacancyCompanyInfo = (props: Props) => {

  const {data, isLoading, refetch} = VacancyCompanyHook.useVacancyCompanies(props.partner.id)

  const vacancyCompanyResponse = data && data[0]

  return (
    <ListGroup className="flex flex-column gap-4">
      <EditVacancyCompany companyId={props.partner.id} isCreate={true} update={refetch}/>
      {vacancyCompanyResponse?.map((vacancyCompany) => (
        <div key={vacancyCompany?.id} className="relative">
          <div className="flex justify-between items-center mb-2">
            <h3 className="m-0 text-lg font-bold">{vacancyCompany?.name}</h3>
            <Dropdown>
              <Dropdown.Toggle  variant="primary" id="dropdown-basic-company" className="border-0 !px-1">
                <i className="fa-solid fa-ellipsis-vertical"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item><EditVacancyCompany companyId={props.partner.id} vacancyCompany={vacancyCompany} update={refetch}/></Dropdown.Item>
                <Dropdown.Item><RemoveVacancyCompany vacancyCompany={vacancyCompany} update={refetch}/></Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <ListGroup.Item>
            <div className="info-item-block">
              <div className="title">БИН</div>
              <div className="value">{vacancyCompany?.bin}</div>
            </div>
          </ListGroup.Item>

          <ListGroup.Item>
            <div className="info-item-block">
              <div className="title">Юридическое имя</div>
              <div className="value">{vacancyCompany?.lawName}</div>
            </div>
          </ListGroup.Item>

          <ListGroup.Item>
            <div className="info-item-block">
              <div className="title">Отображаемое имя</div>
              <div className="value">{vacancyCompany?.name}</div>
            </div>
          </ListGroup.Item>

          <ListGroup.Item>
            <div className="info-item-block">
              <div className="title">Описание</div>
              <div className="value">{vacancyCompany?.description}</div>
            </div>
          </ListGroup.Item>

          <ListGroup.Item>
            <div className="info-item-block">
              <div className="title">Код</div>
              <div className="value">{vacancyCompany?.code}</div>
            </div>
          </ListGroup.Item>
        </div>
      ))}
    </ListGroup>
  )
}